var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DatasetLink',{staticClass:"dataset-link",attrs:{"history_dataset_id":_vm.args.history_dataset_id,"path":_vm.args.path,"label":_vm.args.label}})
}
var staticRenderFns = []

export { render, staticRenderFns }